<div class="modal-header">
  <h5 class="modal-title">{{ ownerCo?.nomComplet }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <!-- Onglets -->
  <ul class="nav nav-tabs mb-3">
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'INFO'" (click)="activeTab = 'INFO'">Informations</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'LOTS'" (click)="activeTab = 'LOTS'">Lots ({{ ownerCo?.homesCo?.length || 0 }})</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'FINANCE'" (click)="activeTab = 'FINANCE'">Finances</a>
    </li>
  </ul>

  <!-- Tab Info -->
  <div *ngIf="activeTab === 'INFO'">
    <div class="row">
      <div class="col-md-6">
        <p><strong>Type :</strong> {{ ownerCo?.type === 'PERSONNE_PHYSIQUE' ? 'Personne physique' : 'Personne morale' }}</p>
        <p><strong>Civilité :</strong> {{ ownerCo?.civilite }}</p>
        <p><strong>Nom :</strong> {{ ownerCo?.nom }}</p>
        <p><strong>Prénom :</strong> {{ ownerCo?.prenom }}</p>
      </div>
      <div class="col-md-6">
        <p><strong>Email :</strong> {{ ownerCo?.email }}</p>
        <p><strong>Téléphone :</strong> {{ ownerCo?.telephone }}</p>
        <p><strong>Adresse :</strong> {{ ownerCo?.adresse }}</p>
        <p><strong>État :</strong>
          <span class="badge" [ngClass]="ownerCo?.etat === 'ACTIF' ? 'badge-success' : 'badge-secondary'">{{ ownerCo?.etat }}</span>
        </p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-4">
        <div class="card bg-light">
          <div class="card-body text-center">
            <h6>Millièmes</h6>
            <h4>{{ ownerCo?.totalMilliemes || 0 }}</h4>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card bg-light">
          <div class="card-body text-center">
            <h6>Crédits</h6>
            <h4 class="text-success">{{ balance?.totalCredit | number:'1.0-0' }} FCFA</h4>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card bg-light">
          <div class="card-body text-center">
            <h6>Solde</h6>
            <h4 [ngClass]="balance?.solde >= 0 ? 'text-success' : 'text-danger'">{{ balance?.solde | number:'1.0-0' }} FCFA</h4>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Tab Lots -->
  <div *ngIf="activeTab === 'LOTS'">
    <table class="table table-sm table-striped table-bordered">
      <thead class="thead-light">
        <tr>
          <th>Nom</th>
          <th>Étage</th>
          <th>N° Lot</th>
          <th>Millièmes</th>
          <th>Type</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let lot of ownerCo?.homesCo">
          <td>{{ lot?.nom }}</td>
          <td>{{ lot?.etage }}</td>
          <td>{{ lot?.numLot }}</td>
          <td class="text-right">{{ lot?.milliemesGeneral || 0 }}</td>
          <td>{{ lot?.type }}</td>
        </tr>
        <tr *ngIf="!ownerCo?.homesCo?.length">
          <td colspan="5" class="text-center text-muted">Aucun lot associé</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Tab Finances -->
  <div *ngIf="activeTab === 'FINANCE'">
    <div class="row mb-3">
      <div class="col-md-8"></div>
      <div class="col-md-4 text-right">
        <button class="btn btn-success btn-sm mr-1" (click)="addCredit('CREDIT')">
          <i class="feather icon-plus"></i> Crédit
        </button>
        <button class="btn btn-danger btn-sm" (click)="addCredit('DEBIT')">
          <i class="feather icon-minus"></i> Débit
        </button>
      </div>
    </div>
    <table class="table table-sm table-striped table-bordered">
      <thead class="thead-light">
        <tr>
          <th>Date</th>
          <th>Référence</th>
          <th>Motif</th>
          <th>Type</th>
          <th>Montant</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of credits">
          <td>{{ c?.date }}</td>
          <td>{{ c?.reference }}</td>
          <td>{{ c?.motif }}</td>
          <td>
            <span class="badge" [ngClass]="c?.type === 'CREDIT' ? 'badge-success' : 'badge-danger'">{{ c?.type }}</span>
          </td>
          <td class="text-right">{{ c?.montant | number:'1.0-0' }} FCFA</td>
          <td class="text-center">
            <button class="btn btn-icon btn-outline-danger btn-sm" (click)="deleteCredit(c)">
              <i class="feather icon-trash"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!credits?.length">
          <td colspan="6" class="text-center text-muted">Aucun mouvement</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()">Fermer</button>
</div>
